export default __webpack_public_path__ + "static/media/929.cbd51160.gif";